import { getModalWindow } from '../foundation';
import {
    LayoutEnum,
    TBottomSheetsWidgetsMap,
    TButtonData,
    TCommonData,
    TModalWidgetsMap,
    TMutableWidgetsData,
    TMutableWidgetsOption,
    TPayloadWidget,
    TWInternalId,
    TModalWindow,
} from '@libs/types';

type TTargetWidget = TPayloadWidget<TMutableWidgetsData & TButtonData, TMutableWidgetsOption>;

type TWidgetByActionWidgetId = {
    widget?: TTargetWidget;
    internalIdWidgets: Record<string, string>;
    bottomSheetMap?: TBottomSheetsWidgetsMap;
    modalWindowMap?: TModalWidgetsMap;
};

type TAccumulator = {
    widget?: TTargetWidget;
    internalIdWidgets: Record<string, string>;
    bottomSheetMap: TBottomSheetsWidgetsMap;
    modalWindowMap: TModalWidgetsMap;
};

const walk = (widgets: TTargetWidget[], internalId: TWInternalId, acc: TAccumulator): void => {
    for (const widget of widgets) {
        if (!widget) continue;
        if (widget.internalId === internalId) {
            acc.widget = widget;
        }
        if (widget.internalId) {
            acc.internalIdWidgets[widget.internalId] = widget.uid;
            const bs = getModal(widget, LayoutEnum.BOTTOM_SHEET);
            if (bs) {
                acc.bottomSheetMap[widget.internalId] = bs;
            } else {
                const modal = getModal(widget, LayoutEnum.MODAL_WINDOW);
                if (modal) {
                    acc.modalWindowMap[widget.internalId] = modal;
                }
            }
        }
        if (widget.widgets?.length) {
            walk(widget.widgets, internalId, acc);
        }
    }
};

export const getWidgetByActionWidgetId = (widgets: TTargetWidget[], internalId: TWInternalId): TWidgetByActionWidgetId => {
    const acc: TAccumulator = {
        internalIdWidgets: {},
        bottomSheetMap: {},
        modalWindowMap: {},
    };
    walk(widgets, internalId, acc);
    const result = {} as TWidgetByActionWidgetId;
    if (acc.widget) result.widget = acc.widget;
    if (Object.keys(acc.internalIdWidgets).length > 0) result.internalIdWidgets = acc.internalIdWidgets;
    if (Object.keys(acc.bottomSheetMap).length > 0) result.bottomSheetMap = acc.bottomSheetMap;
    if (Object.keys(acc.modalWindowMap).length > 0) result.modalWindowMap = acc.modalWindowMap;
    return result;
};

const getModal = (widget: TPayloadWidget<TCommonData>, layoutType: LayoutEnum): TModalWindow | undefined => {
    if (widget.internalId && (widget.alternativeId === layoutType || widget.id === layoutType)) {
        return getModalWindow(widget);
    }
    return undefined;
};
